import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { PageShell } from "../components/PageShell";
import { AppText, Button, Card, Medal, Sticker } from "../components/ui";
import { Seo } from "../components/Seo";
import { api, getSavedProfile } from "../lib/api";

export default function Tarifs() {
  const navigate = useNavigate();
  const choose = async (plan) => {
    const ref = localStorage.getItem("km1_ref") || undefined;
    const pid = getSavedProfile();
    try {
      const res = pid
        ? await api.checkout(pid, plan, undefined, ref)
        : await api.checkoutDiscovery(plan, { anonId: localStorage.getItem("km1_anon_id") || undefined, referralCode: ref });
      if (res.url) { window.location.assign(res.url); return; }
      navigate(pid ? `/programme?profile=${pid}&plan=${plan}` : "/profil");
    } catch (e) { toast.error(e.message || "Paiement indisponible, réessaie"); }
  };
  return (
    <PageShell>
      <Seo title="Tarifs — un programme pour un objectif" description="Essai gratuit 1 mois. Programme 10K 3 mois 14,90 € (courir 5 ou 10 km) ou Programme 21/42K 6 mois 24,90 € (premier semi ou marathon). Paiements uniques, sans abonnement." />
      <AppText variant="display" className="mt-4">Tarifs</AppText>
      <AppText variant="body" className="mt-3 text-km-ontertiary">
        On ne choisit pas au hasard : on choisit un objectif, et on t'aide à le réussir. Tout commence par le profil gratuit : on ne te demande ni compte ni carte pour ça.
      </AppText>

      <div className="flex flex-col gap-3 mt-6">
        <Card className="flex items-center gap-3 p-4">
          <div className="flex-1">
            <AppText variant="bodyStrong">Ton profil de coureur</AppText>
            <AppText variant="caption" className="text-km-muted">5 minutes, sans compte</AppText>
          </div>
          <Sticker text="Gratuit" tone="sage" tilt={4} />
        </Card>

        <button onClick={() => navigate(getSavedProfile() ? `/resultat/${getSavedProfile()}` : "/profil")} data-testid="tarif-essai" className="text-left">
          <Card className="relative flex flex-col items-center gap-1 p-6 border-2 border-km-sage cursor-pointer transition-transform hover:-translate-y-0.5">
            <Sticker text="Pour commencer" tone="sage" tilt={-4} className="absolute -top-3 left-4" />
            <Medal value="01" size={72} />
            <AppText variant="bodyStrong" className="mt-2">Programme ESSAI GRATUIT — 1 mois</AppText>
            <AppText variant="display" className="text-km-sage">0 €</AppText>
            <AppText variant="caption" className="text-km-muted">Sans carte bancaire, non renouvelable</AppText>
            <span className="mt-3 px-5 py-2.5 rounded-full bg-km-sage text-white font-text font-bold text-[15px]">Démarrer mon mois gratuit</span>
          </Card>
        </button>

        <button onClick={() => choose("3m")} data-testid="tarif-3m" className="text-left">
          <Card className="relative flex flex-col items-center gap-1 p-6 border-2 border-km-coral cursor-pointer transition-transform hover:-translate-y-0.5">
            <Sticker text="Le plus choisi" tilt={-4} className="absolute -top-3 left-4" />
            <Medal value="10" size={72} />
            <AppText variant="bodyStrong" className="mt-2">Programme 10K — 3 mois</AppText>
            <AppText variant="display" className="text-km-coral">14,90 €</AppText>
            <AppText variant="caption" className="text-km-muted">Objectif : courir 5 km ou 10 km. Paiement unique.</AppText>
            <span className="mt-3 px-5 py-2.5 rounded-full bg-km-coral text-white font-text font-bold text-[15px]">Je vise le 10K — 14,90 €</span>
          </Card>
        </button>

        <button onClick={() => choose("6m")} data-testid="tarif-6m" className="text-left">
          <Card className="flex flex-col items-center gap-1 p-6 cursor-pointer transition-transform hover:-translate-y-0.5">
            <Medal value="21" size={72} />
            <AppText variant="bodyStrong" className="mt-2">Programme 21/42K — 6 mois</AppText>
            <AppText variant="display" className="text-km-coral">24,90 €</AppText>
            <AppText variant="caption" className="text-km-muted">Objectif : ton premier semi ou ton premier marathon. Paiement unique.</AppText>
            <span className="mt-3 px-5 py-2.5 rounded-full bg-white border-2 border-km-coral text-km-coral font-text font-bold text-[15px]">Je vise le 21/42K — 24,90 €</span>
          </Card>
        </button>

        {!getSavedProfile() ? (
          <Button title="Commencer par mon profil — gratuit" onClick={() => navigate("/profil")} className="mt-2" testID="tarifs-profil-cta" />
        ) : null}
      </div>
    </PageShell>
  );
}
